import { inject, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter, interval } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly snackBar = inject(MatSnackBar);
  private readonly document = inject(DOCUMENT);

  constructor() {
    if (this.swUpdate.isEnabled) {
      // Check for updates every 5 minutes
      interval(5 * 60 * 1000).subscribe(() => {
        this.swUpdate.checkForUpdate().catch((err) => {
          console.error('Error checking for updates', err);
        });
      });

      this.swUpdate.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(() => {
          const snack = this.snackBar.open('New version available', 'REFRESH');
          snack.onAction().subscribe(async () => {
            try {
              await this.swUpdate.activateUpdate();
            } catch (err) {
              console.error('Error activating service worker update:', err);
            }
            this.reloadPage();
          });
        });
    }
  }

  protected reloadPage(): void {
    this.document.defaultView?.location.reload();
  }
}
